var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.3625C3.87812 1.3625 1.55 3.69062 1.55 6.5625C1.55 9.43438 3.87812 11.7625 6.75 11.7625C9.62188 11.7625 11.95 9.43438 11.95 6.5625C11.95 3.69062 9.62188 1.3625 6.75 1.3625ZM0.75 6.5625C0.75 3.24879 3.43629 0.5625 6.75 0.5625C10.0637 0.5625 12.75 3.24879 12.75 6.5625C12.75 9.87621 10.0637 12.5625 6.75 12.5625C3.43629 12.5625 0.75 9.87621 0.75 6.5625Z",
    fill: "#146C94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9502 6.56211C3.9502 6.3412 4.12928 6.16211 4.3502 6.16211H9.15019C9.37111 6.16211 9.55019 6.3412 9.55019 6.56211C9.55019 6.78302 9.37111 6.96211 9.15019 6.96211H4.3502C4.12928 6.96211 3.9502 6.78302 3.9502 6.56211Z",
    fill: "#146C94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7501 3.7627C6.97101 3.7627 7.1501 3.94178 7.1501 4.1627V8.96269C7.1501 9.18361 6.97101 9.36269 6.7501 9.36269C6.52918 9.36269 6.3501 9.18361 6.3501 8.96269V4.1627C6.3501 3.94178 6.52918 3.7627 6.7501 3.7627Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusgroup);
export default __webpack_public_path__ + "static/media/plusgroup.bcb9277c0d8996843b2eb73e48fa0eb8.svg";
export { ForwardRef as ReactComponent };